<template>
	<div class="form-group">
	    <label :for="'input'+content.contenttype"><strong v-if="!name || name == ''">{{content.contenttype}}</strong><strong v-else>{{ name }}</strong></label> 
			<div style="position:relative">
				<tooltip v-model="showSave">Saved</tooltip>

				<input type="text" class="form-control" :id="'input'+content.contenttype" v-model="content.contentvalue" @blur="saveContent" @change="isChange = true">
			</div>
	    
	</div>
</template>

<script>
import axios from 'axios'
import config from '@/config'

import Tooltip from '@/components/elements/Tooltip'

export default{
	props:['value','name'],
	data: function(){
		return {
			showSave : false,
			isChange: false,
			content: this.value
		}
	},
	components: {
		Tooltip
	},
	methods: {
		saveContent: function(){
			if (this.isChange) {
				let vm = this

				api.updateConfig(vm.content,function(error,response){
					if (error) {
						console.error(error)
						return
					}
				})
			}
		}
	},
}
</script>


// WEBPACK FOOTER //
// src/components/view/setting/input/InputText.vue